import "./src/templates/blog-post.css.ts"

/*
import "@fontsource/dm-sans"
import "@fontsource/dm-sans/500.css"
import "@fontsource/dm-sans/700.css"
import "@fontsource/dm-mono"
import "@fontsource/dm-mono/500.css"
import "@fontsource/m-plus-1p"
import "@fontsource/sawarabi-gothic"
import "@fontsource/shippori-antique"
*/


const ensureExternalLinksOpenInNewTab = () => {
  if (typeof document === "undefined") {
    return
  }

  const anchors = document.querySelectorAll("a[href]")

  anchors.forEach((anchor) => {
    const href = anchor.getAttribute("href")

    if (!href || anchor.hasAttribute("download")) {
      return
    }

    const trimmedHref = href.trim()

    if (
      trimmedHref.startsWith("#") ||
      trimmedHref.startsWith("mailto:") ||
      trimmedHref.startsWith("tel:") ||
      trimmedHref.startsWith("javascript:")
    ) {
      return
    }

    let url

    try {
      url = new URL(trimmedHref, window.location.href)
    } catch (error) {
      return
    }

    if (url.origin === window.location.origin) {
      return
    }

    if (!anchor.getAttribute("target")) {
      anchor.setAttribute("target", "_blank")
    }

    const existingRel = anchor.getAttribute("rel")
    const relValues = new Set(
      existingRel ? existingRel.split(/\s+/).filter(Boolean) : []
    )
    relValues.add("noopener")
    relValues.add("noreferrer")

    anchor.setAttribute("rel", Array.from(relValues).join(" "))
  })
}

export const onInitialClientRender = () => {
  ensureExternalLinksOpenInNewTab()
}

export const onRouteUpdate = () => {
  ensureExternalLinksOpenInNewTab()
}